import { RouteConfig } from 'vue-router';
import ProviderApplications from '@/apps/provider/applications/ProviderApplications.vue';
import ProviderApplicationsActive from '@/apps/provider/applications/ProviderApplicationsActive.vue';
import ProviderApplicationsClosed from '@/apps/provider/applications/ProviderApplicationsClosed.vue';
import { requireProvider } from '@/router/guards/authGuards';

const providerApplicationsPageRoutes: RouteConfig[] = [
  {
    path: '/provider/applications',
    component: ProviderApplications,
    beforeEnter: requireProvider,
    children: [
      {
        path: 'active',
        name: 'provider-applications-active',
        component: ProviderApplicationsActive,
      },
      {
        path: 'closed',
        name: 'provider-applications-closed',
        component: ProviderApplicationsClosed,
      },
      {
        path: '',
        redirect: { name: 'provider-applications-active' },
      },
    ],
  },
];

export default providerApplicationsPageRoutes;
